import DashboardWidget from "../DashboardWidget";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import {useForm} from "react-hook-form";
import Input from "../../ui/Input";
import React from "react";
import {useTranslation} from "react-i18next";

const TcknSorgulaWidget = () => {

    const {t} = useTranslation();
    const { register, formState: {errors}} = useForm();

    return (
        <DashboardWidget>
            <div style={{padding: "0 24px", width: "100%"}}>
                <table style={{width: "100%"}}>
                    <tbody>
                    <tr>
                        <td style={{color: "rgba(0, 0, 0, 0.38)"}}>

                            <div style={{color: "rgba(0, 0, 0, 0.6)", fontSize: "16px", lineHeight: "24px"}}>
                                İŞKUR Kayıt Durumu ve <br/> SGK Teşvik Durumu Sorgulama
                            </div>
                            <div style={{marginTop: 20, width: "90%"}}>
                                <Input
                                    error={errors?.tckn}
                                    placeholder={"Adayın T.C. Kimlik Numarasını Yazın"}
                                    {...register("tckn", {
                                        required: t('validation.required'),
                                        minLength: {
                                            value: 11,
                                            message: t('validation.minLength', {val: 11})
                                        },
                                        maxLength: {
                                            value: 11,
                                            message: t('validation.maxLength', {val: 11})
                                        }
                                    })}
                                />
                            </div>
                        </td>
                        <td style={{width: 75}}>
                            <div style={{
                                width: "73px",
                                height: "73px",
                                background: "#7959FB",
                                borderRadius: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}>
                                <SearchOutlinedIcon sx={{color: "#fff", fontSize: "38px"}}/>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </DashboardWidget>
    )

}

export default TcknSorgulaWidget;
